type AppEnv = "development" | "production" | "test" | undefined;
export const API_URL = process.env.NEXT_PUBLIC_SOFIA_API_URL;
export const GOOGLE_MAPS_API_KEY = process.env
  .NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;
export const APP_ENV = process.env.NODE_ENV as AppEnv;
export const IS_PRODUCTION = APP_ENV === "production";
export const IS_DEVELOPMENT =
  APP_ENV === "development" || APP_ENV === undefined;
